module.exports = __webpack_public_path__ + "static/media/blog-starter-kit-optimized.dc5ed124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/99-conclusion/images/blog-starter-kit-optimized.jpg
// module id = 983
// module chunks = 0